const adminBackofficeDictES = {
  adverts: "Anuncios",
  users: "Usuarios",
  orders: "Solicitud",
  paidSubscriptions: "Suscripciones pagas",
  paymentMethod: "Método de pago",
  initialSub: "Registro inicial",
  annualRenewal: "Renovación anual",
  test: "prueba",
  adminDashboard: "Panel Administrativo",
  withdrawRequests: "Solicitudes de retiro",
  excWithdrawRequests: "Retiros Extracoin",
  markExcWithdrawCompleted: "Marcar como completado",
  processThisExcWithdrawRequest: "¿Marcar esta solicitud como completada?",
  excWithdrawProcessedSuccessfully: "¡Solicitud de retiro Extracoin procesada con éxito!",
  searchByUsernameEmailAddress: "Buscar por usuario, correo o dirección",
  requestDate: "Fecha de solicitud",
  processDate: "Fecha de procesamiento",
  processing: "Procesando",
  amountToDeposit: "La cantidad a depositar",
  amountRequested: "Monto requerido",
  processRequest: "Procesa solicitud",
  process: "Proceso",
  processedBy: "Procesado por",
  withdrawProcessedSuccessfully: "¡Solicitud de retiro procesada con éxito!",
  blockOrUnblockUser: "Bloquear/Desbloquear usuario",
  block: "Bloquear",
  unblock: "Desbloquear",
  user: "Usuario",
  processThisRequest: "¿Procesar esta solicitud?",
  userBlockedSuccessfully: "Usuario bloqueado con éxito.",
  userUnblockedSuccessfully: "Usuario desbloqueado con éxito!",
  areYouSureBlockUser: "¿Estás seguro de que quieres bloquear a este usuario?",
  areYouSureUnblockUser: "¿Estás seguro de que quieres desbloquear a este usuario?",
  blocked: "Bloqueado",
  yes: "Sí",
  no: "No",
  category: "Categoría",
  searchCategory: "Buscar Categoría",
  categoriesRegistered: "Categorías Registradas",
  titleCategory: "Título",
  image: "Imagen",
  descriptionPT: "Descripción en portugués",
  descriptionIT: "Descripción en italiano",
  descriptionES: "Descripción en español",
  descriptionEN: "Descripción en inglés",
  registerNewCategory: "registrar nueva categoría",
  addNewCategory: "Agregar nueva categoría",
  newCategory: "Nuevo",
  categoryInfo: "Información de la categoría",
  categoryFields: "Rellena los campos con la información de la categoría.",
  categoryImage: "Imagen de categoría",
  dragImg: "Arrastra tu imagen aquí",
  registerCategory: "Registrar",
  descriptionBrand: "Descripción de la marca",
  brandsRegistered: "Marcas",
  brands: "Marcas",
  addNewBrand: "Agregar nueva marca",
  brandInfo: "Información de la marca",
  brandFields: "Complete el campo con la información de la marca.",
  registerBrand: "Registrarse",
  newBrand: "Nuevo",
  typesCategoriesRegistered: "Tipos Categorías Registradas",
  descriptionType: "Descripción",
  descriptionTypeEN: "Descripción en inglés",
  descriptionTypeES: "Descripción en español",
  descriptionTypeIT: "Descripción en italiano",
  descriptionTypePT: "Descripción en portugués",
  types: "Tipos",
  addNewType: "Agregar nuevos tipos",
  typeInfo: "Información de tipo",
  typeFields: "Rellena los campos con la información del tipo.",
  newType: "Nuevo",
  registerType: "Registrar",
  subcategory: "Subcategorías",
  newsubcategory: "Nuevo",
  subcategoriesRegistered: "Subcategorías registradas",
  descriptionSubcategoryEN: "Descripción en inglés",
  descriptionSubcategoryIT: "Descripción en italiano",
  descriptionSubcategoryPT: "Descripción en portugués",
  descriptionSubcategoryES: "Descripción en español",
  service: "servicio",
  addNewSubcategory: "Agregar nueva subcategoría",
  subcategoryInfo: "Información de subcategoría",
  subcategoryFields: "Rellene los campos con la información de la subcategoría.",
  subcategoryImage: "Imagen de subcategoría",
  registerSubcategory: "Registrar",
  chooseSubcategory: "Elija al menos una subcategoría",
  address: "Dirección",
  userType: "Tipo de usuario",
  chooseUser: "elige un usuario",
  chooseAddress: "elige una dirección",
  UserAddressOnSendCloud: "¿La dirección del usuario estaba registrada en sendcloud?",
  searchUser: "Buscar usuario.",
  userInfo: "informacion del usuario",
  adminBackofficeName: "Nombre",
  hasNoAttribute: "No tiene",
  adminBackofficeUserType: "Tipo de usuario",
  adminBackofficeCountry: "País",
  adminBackofficeAddress: "Dirección",
  adminBackofficeCity: "Ciudad",
  adminBackofficeState: "Estado",
  adminBackofficeDistrict: "Distrito",
  adminBackofficePostalCode: "Código postal",
  adminBackofficeNumber: "Número",
  adminBackofficeComplement: "Complemento",
  adminBackofficeDateCreation: "Fecha de creación",
  adminBackofficePhoneNumber: "Teléfono",
  adminBackofficeOriginRegister: "Registro de origen",
  searchByEmail: "buscar por correo electrónico",
  searchByFirstname: "buscar por nombre",
  searchByPhonenumber: "Buscar por número de teléfono",
  searchByReferralName: "Buscar por referencia",
  searchByBrand: "buscar por marca",
  usersOfSystem: "Usuarios del sistema",
  productsNotPublished: "Productos no publicados",
  archivedProducts: "Productos archivados",
  productsPublished: "Productos publicados",
  salesRevenue: "Ingresos por ventas",
  feeRevenue: "Ingresos por comisiones",
  registeredStores: "Tiendas registradas",
  completedOrders: "Pedidos completados",
  revenueFromUserRegistration: "Ingresos por registro de usuarios",
  productsOfSystem: "Productos del sistema",
  filters: "Filtros",
  search: "Buscar",
  searchByNameSurnameUserAccountBank: "Buscar por nombre, apellido, usuario, cuenta bancaria",
  ordersPlacedWithBangood: "Pedidos realizados con Bangood",
  actions: "Acciones",
  processOrderSuccessfully: "¡Pedido procesado con éxito!",
  metaAdsConfig: "Configurar anuncios de Meta",
  integrationConfig: "Ajustes de integración",
  editIntegrationConfig: "Editar configuración",
  accessToken: "Clave de acceso",
  pixelNumberId: "Número de identificación de Pixel",
  savePixelConfig: "Guardar configuración",
  integrations: "Integraciones",
  pixelConfigSaved: "Configuración guardada.",
  pixelConfigSavedDetail: "La configuración de su metaanuncio se ha guardado correctamente.",
  pixelConfigError: "Error inesperado",
  pixelConfigErrorDetail: "Se ha producido un error al intentar guardar la configuración.",
  fillInAllFields: "¡Rellena todos los campos!",
  googleTagManagerConfiguration: "Configurar el Google Tag Manager",
  gtmCodeSaved: "Código GTM guardado",
  gtmCode: "Código GTM",
  gtmEdit: "Editar código GTM",
  gtmRegister: "Registrar código GTM",
  confirmed: "Pago confirmado",
  paymentConfirmed:
    "Ha confirmado correctamente la recepción del pago mediante transferencia bancaria.",
  pendingOrders: "Pedidos pendientes",
  transferConfirm: "Confirmar transferencia",
  buyer: "Comprador",
  totalAmount: "Valor total",
  date: "Fecha",
  noPendingOrders: "No hay órdenes de transferencia pendientes.",
  youHavePendingOrders: "Tiene ventas pendientes",
  youHavePendingUsers: "Tiene usuarios pendientes",
  seeYourPendingOrders: "Compruebe sus ventas pendientes por transferencia bancaria.",
  seeYourPendingUsersBankTransfer: "Verifique sus usuarios pendientes por transferencia bancaria.",
  pendings: "Ventas pendientes",
  usersPendings: "Usuarios pendientes",
  bankTransfers: "Transferencias bancarias",
  searchForPlan: "Buscar por plan",
  authorize: "Autorizar",
  confirmTransfer: "¿Confirmar transferencia?",
  receipt: "Comprobante",
  pendingIssues: "Problemas pendientes",
  quantityOfWithdrawsCompleted: "Cantidad de retiros completados",
  totalAmountWithdrawsCompleted: "Valor total de retiros completados",
  totalOfUsersPublishedAds: "Total de usuarios con anuncios publicados",
  totalofCommissionsPaid: "Total de comisiones pagadas",
  bestOffers: "MEJORES OFERTAS",
  youHaveUnprocessedOrders: "Tiene pedidos de Bangood sin procesar",
  pendingBangoodOrders: "Ver sus pedidos de Bangood no procesados.",
  bannersOfShop: "Banners de la tienda",
  dragJustOneImage: "Arrastra solo una imagen",
  language: "Idioma",
  english: "Inglés",
  portuguese: "Portugués",
  italian: "Italiano",
  spanish: "Español",
  dontHaveImage: "¿No tienes una imagen?",
  principalBanner: "Banner principal",
  file: "Archivo",
  showBanner: "Mostrar banner",
  noImageSelected: "No hay ninguna imagen seleccionada",
  keepImageInRequiredAspectRatio: "Mantenga la imagen en la relación de aspecto requerida",
  doYouWantToRepeatThisImage: "¿Quieres repetir esta imagen para otro banner?",
  documents: "Documentos",
  document: "Documento",
  seeDoc: "Ver documento",
  downloadDoc: "Descargar documento",
  urlToRedirect: "URL para redirigir al usuario al hacer clic en el banner",
  addNewBanner: "Agregar nuevo banner",
  removeBanner: "Eliminar banner",
  settingsSaved: "Configuraciones guardadas",
  generalSettings: "Configuración general",
  sliderChangeTime: "Tiempo de cambio del control deslizante",
  seconds: "Artículos de segunda clase",
  imageDesktopEnglish: "Imagen de escritorio en inglés",
  imageDesktopItalian: "Imagen de escritorio en italiano",
  imageDesktopPortuguese: "Imagen de escritorio en portugués",
  imageDesktopSpanish: "Imagen de escritorio en español",
  imageMobileEnglish: "Imagen móvil en inglés",
  imageMobileItalian: "Imagen móvil en italiano",
  imageMobilePortuguese: "Imagen móvil en portugués",
  imageMobileSpanish: "Imagen móvil en español",
  youHavePendingWithdraws: "Tiene retiros pendientes",
  seeYourPendingWithdraws: "Ver sus retiros pendientes.",
  youHavePendingPhysicalStores: "Tiene tiendas físicas pendientes de verificación",
  seeYourPendingPhysicalStores: "Revise las tiendas que esperan aprobación.",
  withdrawPendings: "Retiros pendientes",
  subnets: "Subredes",
  ownerName: "Nombre del propietario",
  pleaseEnterName: "Por favor, ingrese un nombre",
  pleaseEnterDescription: "Por favor, ingrese una descripción",
  pleaseSelectManager: "Por favor, seleccione un manager",
  whitelabelSubnetCreatedSuccessfully: "Subnet Whitelabel creada con éxito",
  errorCreatingWhitelabelSubnet: "Error al crear la subred Whitelabel",
  personalizeSubnetTheme: "Personalizar el tema de la subred",
  personalizeTeam: "Personalizar tema",
  reports: "Informes contables",
  paidOrdersReport: "Informe de Pedidos Pagados",
  completedWithdrawalsReport: "Informe de Retiros Completados",
  paidSubscriptionsReport: "Informe de Suscripciones Pagadas",
  downloadPdf: "Descargar PDF",
  noData: "No hay datos disponibles",
  pdfDownloadedSuccessfully: "PDF descargado con éxito",
  errorDownloadingPdf: "Error al descargar PDF",
  errorFetchingData: "Error al obtener datos",
  success: "Éxito",
  taxId: "NIF/CIF",
  planType: "Tipo de plan",
  startDate: "Fecha de inicio",
  endDate: "Fecha de fin",
  exportData: "Exportar datos",
  paidOrdersHeaderNumber: "N°",
  paidOrdersHeaderBuyer: "Comprador",
  paidOrdersHeaderSeller: "Vendedor",
  paidOrdersHeaderDate: "Fecha",
  paidOrdersHeaderOrderAmount: "Imp. Pedido",
  paidOrdersHeaderPaidAmount: "Imp. Pagado",
  paidOrdersHeaderCommission: "Comisión",
  paidOrdersHeaderPayPal: "PayPal",
  paidOrdersHeaderWallet: "Billetera",
  paidOrdersHeaderExtraCredit: "ExtraCredit",
  paidOrdersHeaderBankTransfer: "Transferencia",
  paidOrdersHeaderStatus: "Estado",
  paidOrdersHeaderInvoiceBuyer: "Factura Comprador",
  paidOrdersHeaderInvoiceSeller: "Factura Vendedor",
  paidOrdersHeaderPlatformFeeBuyer: "Tarifa de Plataforma Comprador (5%)",
  paidOrdersHeaderPlatformFeeSeller: "Tarifa de Plataforma Vendedor (5%)",
  paidOrdersHeaderPaidToSeller: "Pagado al Vendedor",
  paidOrdersStatusOnHold: "En espera",
  completedWithdrawalsHeaderId: "ID",
  completedWithdrawalsHeaderDestination: "Destino",
  completedWithdrawalsHeaderProcessedBy: "Procesado por",
  completedWithdrawalsHeaderRequestDate: "Fecha de solicitud",
  completedWithdrawalsHeaderProcessDate: "Fecha de proceso",
  completedWithdrawalsHeaderAmountRequested: "Importe solicitado",
  completedWithdrawalsHeaderAmountToDeposit: "Importe a depositar",
  completedWithdrawalsHeaderFee: "Tarifa",
  completedWithdrawalsColDestinationType: "Tipo Dest.",
  completedWithdrawalsColPayment: "Pago",
  completedWithdrawalsColRequestedValue: "Imp. Sol.",
  completedWithdrawalsColNetValue: "Imp. Neto",
  completedWithdrawalsDestinationTypePaypal: "PayPal",
  searchBySurname: "Buscar por apellido",
  searchByDocument: "Buscar por documento",
  searchByAddress: "Buscar por dirección",
  searchByPaymentMethod: "Buscar por método de pago",
  orderNumber: "Número de pedido",
  logoutAccount: "Cerrar sesión",
  logoOrFavicon: "Puede enviar solo el logo, solo el favicon o ambos",
  footerFieldsInfo:
    "Los campos a continuación aparecerán en el pie de página del panel de control del whitelabel.",
  approveStore: "Aprobar tienda",
  rejectStore: "Rechazar tienda",
  confirmApproveStore: "¿Está seguro de que desea aprobar esta tienda?",
  enterRejectionReason: "Ingrese el motivo del rechazo",
  storeApprovedSuccessfully: "¡Tienda aprobada con éxito!",
  storeRejectedSuccessfully: "¡Tienda rechazada con éxito!",
  physicalStores: "Tiendas Físicas",
  physicalStoresRegistered: "Tiendas Físicas Aprobadas",
  physicalStoresApproved: "Tiendas Aprobadas",
  physicalStoresPending: "Verificaciones Pendientes",
  searchByStoreName: "Buscar por nombre de tienda",
  physicalStoreName: "Nombre de la tienda",
  storeOwner: "Propietario",
  viewDetails: "Ver detalles",
  storeDetails: "Detalles de la tienda",
  conventionPdf: "PDF del Convenio",
  legalRepresentative: "Representante legal",
  piva: "PIVA (Partita IVA)",
  signatureIp: "IP de la firma",
  signedAt: "Firmado el",
  openPhoto: "Abrir foto",
  openConvention: "Abrir PDF del convenio",
  establishmentPhoto: "Foto del establecimiento",
  verificationStatus: "Estado",
  submittedAt: "Enviado el",
  statusPending: "Pendiente",
  statusApproved: "Aprobada",
  statusRejected: "Rechazada",
  storeCompanyName: "Razón social",
  commercialName: "Nombre comercial",
  merchantCategory: "Categoría del establecimiento",
  storePhone: "Teléfono de la tienda",
  invoiceStatus: "Facturación",
  invoiceStatusSent: "Factura emitida",
  invoiceStatusError: "Error al emitir factura",
  invoiceStatusPending: "Factura pendiente",
  invoiceStatusNotApplicable: "No aplicable",
  automaticInvoicing: "Facturación Automática",
  automaticInvoicingDescription: "Habilita o deshabilita la emisión automática de la factura electrónica para las suscripciones pagadas y los pedidos.",
  invoicingEnabledSuccessfully: "Facturación automática habilitada con éxito",
  invoicingDisabledSuccessfully: "Facturación automática deshabilitada con éxito",
  errorTogglingInvoicing: "Error al cambiar la facturación automática",
  errorFetchingInvoicingStatus: "Error al buscar el estado de la facturación automática",
};

export default adminBackofficeDictES;
